import React from 'react';

import usePrefix from 'utils/usePrefix';

import NoData from 'components/NoData';

import { Wrapper } from './styles';
import Content from './Content';

interface Props {
  chatId: number;
  onClear: () => void;
  handleInactiveChat: (deactivation_time: string | null) => void;
  deactivationTime: string | null;
  fetchTags: () => void;
  setChatPadding: (set: boolean) => void;
}

const ChatMeta: React.FC<Props> = ({
  chatId,
  onClear,
  handleInactiveChat,
  deactivationTime,
  fetchTags,
  setChatPadding,
}) => {
  const t = usePrefix('Chat');

  return (
    <Wrapper>
      {chatId ? (
        <Content
          chatId={chatId}
          onClear={onClear}
          handleInactiveChat={handleInactiveChat}
          deactivationTime={deactivationTime}
          fetchTags={fetchTags}
          setChatPadding={setChatPadding}
        />
      ) : (
        <NoData title={t('no_messages')} />
      )}
    </Wrapper>
  );
};

export default ChatMeta;
